import { FEATURES } from '@constants/Text'
import { lazyLoadView } from '@utils/LazyLoad'

// ATENCAO: vue-router 3 NÃO funde `meta` de pai e filho: usa o do registro mais
// profundo. `can_show` e `permission` precisam estar REPETIDOS no filho, senão
// um F5 direto na URL cai em /404 (ou pior, escapa do gate).
const meta = {
  permission: ['profissional'],
  can_show: FEATURES.CLIENT_JOURNEY,
  // Sem `search` a página fica invisível no Ctrl+K e só é alcançável pelo perfil
  // do cliente ou por link direto — quem sabe que ela existe não chega por busca.
  search: {
    title: 'Resumo do cliente',
    description:
      'Jornada do cliente: etapas concluídas, o que falta e a próxima ação',
    keywords: [
      'jornada',
      'resumo',
      'cliente',
      'etapas',
      'esteira',
      'onboarding',
      'compliance',
      'próxima ação',
      'sla',
    ],
  },
}

export default [
  {
    path: '/resumo-cliente',
    component: () =>
      lazyLoadView(
        import(
          /* webpackChunkName: "client-journey" */ '@modules/client-journey/views/nav-bar/client-journey-nav-bar.vue'
        )
      ),
    meta,
    children: [
      {
        // `:id?` opcional: a entrada pelo switcher chega sem id e a própria
        // view completa a URL, para o link ficar compartilhável.
        path: ':id?',
        name: 'client-journey.resumo',
        meta,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "client-journey" */ '@modules/client-journey/views/resumo/view-client-journey-resumo.vue'
            )
          ),
      },
    ],
  },
]
